// Range Rats Theme — theme.js

(function () {
  'use strict';

  // ── NAV SCROLL ─────────────────────────────────────────
  var nav = document.querySelector('.nav');
  if (nav) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          nav.classList.toggle('scrolled', window.scrollY > 40);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ── SCROLL REVEAL ───────────────────────────────────────
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.classList.add('visible');
          }, i * 80);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    // Fallback: show all immediately
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  // ── VARIANT SELECTOR (product page) ────────────────────
  var variantSelects = document.querySelectorAll('[data-variant-select]');
  variantSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (!form) return;
      var priceEl = form.querySelector('[data-product-price]');
      var selectedOption = select.options[select.selectedIndex];
      if (priceEl && selectedOption.dataset.price) {
        priceEl.textContent = selectedOption.dataset.price;
      }
    });
  });

  // ── SIZE BUTTON TOGGLE ──────────────────────────────────
  document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.product-option-values');
      if (group) {
        group.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
      }
      btn.classList.add('active');
    });
  });

})();
